interface Props {
  icon?: string;
  message: string;
  // 'neutral' existe para la pantalla de "no es tu momento": ni verde de
  // celebración ni rojo de error, porque lo que pasó no es ninguna de las dos.
  variant?: 'urgent' | 'warning' | 'success' | 'neutral';
}

export function UrgencyBanner({ icon = '🔥', message, variant = 'urgent' }: Props) {
  const colors: Record<string, string> = {
    urgent: 'bg-red-600/90 text-white',
    warning: 'bg-amber-500/90 text-black',
    success: 'bg-emerald-600/90 text-white',
    neutral: 'bg-hit-dark text-hit-gold border-b border-hit-gold/25',
  };

  return (
    <div
      className={`${colors[variant]} py-3 px-4 text-center font-bold sticky top-0 z-50 text-sm`}
      role="status"
      aria-live="polite"
    >
      <span className="mr-2" aria-hidden="true">
        {icon}
      </span>
      {message}
    </div>
  );
}
